export const scrollToTop = (behavior = 'instant') => {
    window.scrollTo({ top: 0, behavior });
};
